import styled from 'styled-components';

import Color from '../../styles/color';
import footerHeight from '../../constants/footer.constant';

type Props = {
  dark?: boolean;
  paddingBottom?: boolean;
};

type ScrollProps = {
  scrollPosition?: number;
};

function getMinHeight() {
  return `${window.innerHeight}px`;
}

const getBotton = (scrollPosition?: number) => {
  if (scrollPosition === undefined) {
    return document.body.scrollHeight > window.innerHeight
      ? '0px'
      : `${footerHeight}px`;
  }

  if (scrollPosition >= footerHeight) {
    return '0px';
  }

  return `${footerHeight - scrollPosition}px`;
};

export const Title = styled.h1`
  font-size: 24px;
  color: ${Color.neutral};
  font-weight: 500;
  margin-bottom: 16px;
`;

export const Loading = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
  margin-top: 20px;

  span {
    font-weight: 500;
    color: ${Color.primary};
    size: 16px;
  }
`;

export const Container = styled.div<Props>`
  position: relative;
  width: 100%;
  min-height: ${getMinHeight()};
  background-color: ${p => (p.dark ? Color.neutral20 : Color.white)};
  padding-bottom: ${p => (p.paddingBottom ? '104px' : '0px')};
  justify-content: space-between;
`;

export const Content = styled.div`
  width: 100%;
  margin-top: 30px;
  padding: 0px 16px;
  box-sizing: border-box;
  padding-bottom: calc(${footerHeight}px + 16px);
`;

export const Bottom = styled.div`
  position: absolute;
  width: 100%;
  bottom: calc(${footerHeight}px + 16px);
  box-sizing: border-box;
  padding: 0px 16px;
`;

export const OverContent = styled.div<ScrollProps>`
  position: fixed;
  width: 100%;
  padding: 16px;
  border-top: 1px solid ${Color.neutral60};
  bottom: ${p => getBotton(p.scrollPosition)};
  background-color: ${Color.white};
  box-sizing: border-box;
`;
